import { render } from "./DigilamVsLitholamCosts.vue?vue&type=template&id=411f35a0&scoped=true"
const script = {}

import "./DigilamVsLitholamCosts.vue?vue&type=style&index=0&id=411f35a0&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-411f35a0"]])

export default __exports__